exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__list___K4fBH {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; }\n\n.styles__title___R7sb1 {\n  display: block; }\n\n.styles__itemCell___1FPax {\n  display: block;\n  margin-bottom: 0 !important; }\n\n.styles__row___18XMW {\n  display: flex;\n  align-items: center;\n  gap: 10px; }\n  .styles__row___18XMW > :first-child {\n    flex: 1;\n    min-width: 0; }\n    @media (min-width: 768px) {\n      .styles__row___18XMW > :first-child {\n        flex: 0 0 calc((100% - 32px) / 3); } }\n\n.styles__removeRow___2p3pI {\n  display: block;\n  cursor: pointer;\n  flex-shrink: 0; }\n  .styles__removeRow___2p3pI > img {\n    width: 20px;\n    height: 20px; }\n\n.styles__addRow___2fIo6 {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  color: #f94144; }\n  .styles__addRow___2fIo6 > span {\n    margin-left: 8px;\n    font-weight: 600;\n    text-decoration: underline; }\n", ""]);

// exports
exports.locals = {
	"list": "styles__list___K4fBH",
	"title": "styles__title___R7sb1",
	"itemCell": "styles__itemCell___1FPax",
	"row": "styles__row___18XMW",
	"removeRow": "styles__removeRow___2p3pI",
	"addRow": "styles__addRow___2fIo6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/InputTextList/styles.scss
// module id = 4631
// module chunks = 6